export var WidgetEvent;
(function (WidgetEvent) {
    WidgetEvent["RouteExecutionStarted"] = "routeExecutionStarted";
    WidgetEvent["RouteExecutionUpdated"] = "routeExecutionUpdated";
    WidgetEvent["RouteExecutionCompleted"] = "routeExecutionCompleted";
    WidgetEvent["RouteExecutionFailed"] = "routeExecutionFailed";
})(WidgetEvent || (WidgetEvent = {}));
